var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUpAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.259-.019.2.01c1.027.085 2.39.841 2.39 3.022l-.011.306c-.053.75-.267 1.677-.269 1.686h3.15l.192.006c1.946.134 2.777 2.308 1.426 3.95.146.331.228.698.228 1.083l-.005.164a2.69 2.69 0 0 1-1.074 1.988c-.221 1.495-1.335 2.652-3.15 2.79l-.371.014H7.97l-.355-.01a5.6 5.6 0 0 1-1.73-.367l-.222-.093a2.4 2.4 0 0 1-.351-.196c-.251.39-.646.667-1.12.667h-1.99c-.861 0-1.684-1.683-1.684-4.486s.823-4.487 1.684-4.487h1.99c.287 0 .545.102.76.268.804-1.694 1.292-3.501 1.504-5.368L6.5.5c.011-.011.53-.518 1.759-.519m-5.82 7.347a2 2 0 0 0-.198.382c-.231.57-.424 1.513-.424 2.805 0 1.291.193 2.235.424 2.804.076.186.147.307.197.381h1.967l-.11-.437c-.214-.888-.3-1.818-.3-2.748q0-.476.032-.948c.036-.6.114-1.176.24-1.673.042-.186.138-.559.138-.559zm5.82-6.047c-.23 0-.41.026-.545.057-.278 2.188-.914 4.314-1.98 6.293a2.6 2.6 0 0 0-.206.575 10 10 0 0 0-.208 1.502 13 13 0 0 0 .103 2.467l.042.215c.122.478.402.807.727.953l.165.07c.403.156.94.287 1.613.287h2.995c.753 0 1.267-.22 1.598-.499.53-.446.82-1.125.715-1.724 1.052-.579 1.296-1.73.547-2.724.752-.52 1.475-2.232.04-2.434l-.145-.014H8.937l.366-1.592.127-.642c.05-.29.092-.59.11-.835l.01-.223c0-.85-.271-1.237-.477-1.423a1.25 1.25 0 0 0-.716-.304z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpAction);
export default __webpack_public_path__ + "static/media/thumbUpAction.fafbbdd3d1fe1e814900a7ff297bad34.svg";
export { ForwardRef as ReactComponent };